// Configuration - Single source of truth for all hardcoded values

export const config = {
  // Phone numbers
  phoneNumber: '919315630570',
  whatsappBaseUrl: 'https://api.whatsapp.com/send/',

  // Analytics
  analytics: {
    ga4Id: 'G-6MQ93ZM5L9',
    facebookPixelId: '640349758813782',
    googleAdsConversionId: 'AW-17326322467'
  },

  // Form endpoints
  forms: {
    googleAppsScriptUrl: '', // TODO: Add actual URL
    newsletterRedirectEnabled: true
  },

  // Animation defaults
  animation: {
    fadeThreshold: 0.1,
    fadeRootMargin: '0px 0px -50px 0px',
    scrollThreshold: 100,
    headerScrollClass: 'scrolled'
  },

  // Validation
  validation: {
    emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phoneRegex: /^\+?[0-9]{10,15}$/
  },

  // Services mapping
  services: {
    vastu: 'Vastu Shastra Consultation',
    akashic: 'Akashic Records Reading',
    healing: 'Spiritual Healing',
    astrology: 'Astrology Consultation',
    combined: 'Combined Services',
    other: 'Other Inquiry'
  },

  // Page names
  pages: {
    home: 'Home Page',
    vastu: 'Vastu Consultation Page',
    astrology: 'Astrology Consultation Page',
    healing: 'Spiritual Healing Page',
    akashic: 'Akashic Reading Page'
  }
};

// Export types for configuration
export type Config = typeof config;
